module.exports = __webpack_public_path__ + "media/images/vendors/missing_vendors_small-3b407f722a710fa72e8502473d53ebe2.png";